(function () {
  var emotionClassMap = {
    NEUTRAL: 'neutral',
    HAPPY: 'happy',
    ANGRY: 'angry',
    SAD: 'sad',
    SURPRISED: 'surprised',
    FEARFUL: 'fearful',
    DISGUSTED: 'disgusted'
  };

  function emotionClass(name) {
    return emotionClassMap[name] ? ' self-reflection__analysis-emotion--' + emotionClassMap[name] : '';
  }

  function setAccuracyLabel(root) {
    var label = root.querySelector('.self-reflection__analysis-header > span:first-child');
    if (label) {
      label.textContent = 'EMOTION ACCURACY';
      label.classList.add('self-reflection__analysis-label');
    }
  }

  function formatGroup(root) {
    var group = root.querySelector('[data-sr-analysis-group]');
    if (!group) return;

    var text = (group.textContent || '').trim();
    if (!text && group.children.length) return;
    if (!text) return;

    text = text
      .replace('SHARED DOMINANT EXPRESSION', 'SHARED MOMENT EXPRESSION')
      .replace('MIXED DOMINANT EXPRESSIONS', 'SHARED MOMENT EXPRESSION: MIXED')
      .replace('MIXED MOMENT EXPRESSIONS', 'SHARED MOMENT EXPRESSION: MIXED');

    var value = '';
    var bits = text.split(':');
    if (bits.length > 1) value = bits.slice(1).join(':').trim();
    if (!value) value = text.replace('SHARED MOMENT EXPRESSION', '').trim();
    value = value || 'MIXED';

    group.textContent = '';

    var label = document.createElement('span');
    label.className = 'self-reflection__analysis-label';
    label.textContent = 'SHARED MOMENT EXPRESSION:';

    var answer = document.createElement('strong');
    answer.textContent = value.toUpperCase();

    group.appendChild(label);
    group.appendChild(answer);
  }

  function wrapReading(reading) {
    if (!reading) return;

    var text = (reading.textContent || '').trim();
    if (!text) return;

    var parts = text.split('/').map(function (part) {
      return part.trim();
    }).filter(Boolean);

    if (!parts.length) return;

    reading.textContent = '';
    reading.classList.add('self-reflection__analysis-reading');

    parts.forEach(function (part, index) {
      if (index) reading.appendChild(document.createTextNode(' / '));

      var emotionName = (part.match(/^([A-Z]+)/) || [])[1];
      var span = document.createElement('span');
      span.className = 'self-reflection__analysis-emotion' + emotionClass(emotionName);
      span.textContent = part;
      reading.appendChild(span);
    });
  }

  function update() {
    var root = document.querySelector('[data-self-reflection]');
    if (!root) return;

    setAccuracyLabel(root);
    formatGroup(root);

    Array.prototype.forEach.call(
      root.querySelectorAll('.self-reflection__analysis-person > span:last-child'),
      wrapReading
    );
  }

  function mountMobileTwoThreeStyle() {
    if (document.getElementById('aeliza-self-reflection-mobile-two-three')) return;

    var style = document.createElement('style');
    style.id = 'aeliza-self-reflection-mobile-two-three';
    style.textContent = [
      '@media (max-width: 900px) {',
      '  [data-self-reflection] .self-reflection__stage {',
      '    aspect-ratio: 2 / 3 !important;',
      '    width: 100vw !important;',
      '    height: auto !important;',
      '    min-height: 0 !important;',
      '    max-height: none !important;',
      '  }',
      '}',
      '@media (max-height: 700px) and (max-width: 900px) {',
      '  [data-self-reflection] .self-reflection__stage {',
      '    width: 100vw !important;',
      '    aspect-ratio: 2 / 3 !important;',
      '    margin-left: 0 !important;',
      '    margin-right: 0 !important;',
      '  }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function init() {
    mountMobileTwoThreeStyle();

    var root = document.querySelector('[data-self-reflection]');
    if (!root || root.dataset.readingColorBridge === 'true') return;
    root.dataset.readingColorBridge = 'true';

    root.addEventListener('sr:capture', function () {
      window.setTimeout(update, 40);
      window.setTimeout(update, 180);
      window.setTimeout(update, 420);
    });

    root.addEventListener('sr:retake', function () {
      window.setTimeout(update, 40);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  var targetWidth = 1080;
  var sourceHeight = 1920;
  var targetHeight = 1620;

  function isMobileReflectionExport(canvas) {
    return canvas &&
      canvas.width === targetWidth &&
      canvas.height === sourceHeight &&
      window.matchMedia &&
      window.matchMedia('(max-width: 900px)').matches;
  }

  function drawTwoThree(sourceCanvas) {
    var out = document.createElement('canvas');
    out.width = targetWidth;
    out.height = targetHeight;
    var ctx = out.getContext('2d');
    var cropY = Math.round((sourceHeight - targetHeight) / 2);
    ctx.drawImage(sourceCanvas, 0, cropY, targetWidth, targetHeight, 0, 0, targetWidth, targetHeight);
    return out;
  }

  var nativeToBlob = HTMLCanvasElement.prototype.toBlob;
  if (nativeToBlob && !HTMLCanvasElement.prototype.__aelizaTwoThreeToBlob) {
    HTMLCanvasElement.prototype.__aelizaTwoThreeToBlob = true;
    HTMLCanvasElement.prototype.toBlob = function (callback, type, quality) {
      if (isMobileReflectionExport(this)) {
        return nativeToBlob.call(drawTwoThree(this), callback, type, quality);
      }
      return nativeToBlob.call(this, callback, type, quality);
    };
  }

  var nativeToDataURL = HTMLCanvasElement.prototype.toDataURL;
  if (nativeToDataURL && !HTMLCanvasElement.prototype.__aelizaTwoThreeToDataURL) {
    HTMLCanvasElement.prototype.__aelizaTwoThreeToDataURL = true;
    HTMLCanvasElement.prototype.toDataURL = function (type, quality) {
      if (isMobileReflectionExport(this)) {
        return nativeToDataURL.call(drawTwoThree(this), type, quality);
      }
      return nativeToDataURL.call(this, type, quality);
    };
  }

  var nativeCaptureStream = HTMLCanvasElement.prototype.captureStream;
  if (nativeCaptureStream && !HTMLCanvasElement.prototype.__aelizaTwoThreeCaptureStream) {
    HTMLCanvasElement.prototype.__aelizaTwoThreeCaptureStream = true;
    HTMLCanvasElement.prototype.captureStream = function (frameRate) {
      if (!isMobileReflectionExport(this)) {
        return nativeCaptureStream.call(this, frameRate);
      }

      var source = this;
      var proxy = document.createElement('canvas');
      proxy.width = targetWidth;
      proxy.height = targetHeight;
      var ctx = proxy.getContext('2d');
      var cropY = Math.round((sourceHeight - targetHeight) / 2);
      var frame;

      function draw() {
        ctx.clearRect(0, 0, targetWidth, targetHeight);
        ctx.drawImage(source, 0, cropY, targetWidth, targetHeight, 0, 0, targetWidth, targetHeight);
        frame = window.requestAnimationFrame(draw);
      }

      draw();

      var stream = nativeCaptureStream.call(proxy, frameRate);
      stream.getTracks().forEach(function (track) {
        track.addEventListener('ended', function () {
          window.cancelAnimationFrame(frame);
        });
      });
      return stream;
    };
  }
})();
